export default "__VITE_ASSET__d6c7d930__"